import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useErrorToast } from '../toast/useErrorToast';
import { customAuthAxios } from '../../utils/customAuthAxios';


const apiUrlLogin = `${process.env.REACT_APP_API_URL}authen/jwt/create/`;


export const useLoginSalesman = () => {
  const navigate = useNavigate();
  const showErrorToast = useErrorToast();

  const onSubmit = async (data:any) => {
    try {
      const authRes = await axios.post(apiUrlLogin, data, { headers: { 'Content-Type': 'application/json' } });
      const token = authRes.data.access;
      localStorage.clear();
      localStorage.setItem('localJWT', token);
      const salesmanRes = await customAuthAxios.get(`accounts/salesmen/me/`);
      navigate(`/salesmen/${salesmanRes.data.id}/restaurants`)
    } catch (error:any) {
      if (error.response?.status === 401) {
        showErrorToast("ユーザーネームまたはパスワードが誤っています。");
      } else if (error.response?.status === 404) {
        navigate('/restaurant-login')
      } else {
        console.error("An unexpected error occurred:", error);
        showErrorToast("予期せぬエラーが発生しました。");
      }
    }
  };
  return onSubmit;
};